const state = {
    smsEdit: null,
    smsDelete: null
}
export default state